const OUTPUT = {
  duration: {
    id: "duration",
    output_id: "RLDUR",
    descricao: "Duration",
    maxWidth: "lg",
    config: {
      title: "Configurações",
      subtitle: "Duration",
      descricao: "",
    },
    config_add: {
      title: "Novo",
      subtitle: "Duration / Configurações",
      descricao: "",
    },
    config_edit: {
      title: "Editar",
      subtitle: "Duration / Configurações",
      descricao: "",
    },
  },
  var: {
    id: "var",
    output_id: "RLVAR",
    descricao: "Risco",
    maxWidth: "lg",
    config: {
      title: "Configurações",
      subtitle: "Risco",
      descricao: "",
    },
    config_add: {
      title: "Novo",
      subtitle: "Risco / Configurações",
      descricao: "",
    },
    config_edit: {
      title: "Editar",
      subtitle: "Risco / Configurações",
      descricao: "",
    },
  },
  enquadramento: {
    id: "enquadramento",
    output_id: "RLENQ",
    descricao: "Enquadramento",
    maxWidth: "lg",
    config: {
      title: "Configurações",
      subtitle: "Enquadramento",
      descricao: "",
    },
    config_add: {
      title: "Novo Enquadramento",
      subtitle: "Enquadramento / Configurações",
      descricao: "",
    },
    config_edit: {
      title: "Editar Enquadramento",
      subtitle: "Enquadramento / Configurações",
      descricao: "",
    },
  },
  raiox: {
    id: "raiox",
    output_id: "RLRAX",
    descricao: "Raio X",
    maxWidth: "lg",
    config: {
      title: "Configurações",
      subtitle: "Raio X",
      descricao: "",
    },
    config_add: {
      title: "Novo",
      subtitle: "Raio X / Configurações",
      descricao: "",
    },
    config_edit: {
      title: "Editar",
      subtitle: "Raio X / Configurações",
      descricao: "",
    },
  },
  rentabilidade: {
    id: "rentabilidade",
    output_id: "RLREN",
    descricao: "Rentabilidade",
    maxWidth: "lg",
    config: {
      title: "Configurações",
      subtitle: "Rentabilidade",
      descricao: "",
    },
    config_add: {
      title: "Novo",
      subtitle: "Rentabilidade / Configurações",
      descricao: "",
    },
    config_edit: {
      title: "Editar",
      subtitle: "Rentabilidade / Configurações",
      descricao: "",
    },
  },
  stresstest: {
    id: "stresstest",
    output_id: "RLSTT",
    descricao: "Stress Test",
    maxWidth: "xl",
    config: {
      title: "Configurações",
      subtitle: "Stress Test",
      descricao: "",
    },
    config_add: {
      title: "Novo Cenário",
      subtitle: "Stress Test / Configurações",
      descricao: "",
    },
    config_edit: {
      title: "Editar Cenário",
      subtitle: "Stress Test / Configurações",
      descricao: "",
    },
  },
  backtesting: {
    id: "backtesting",
    output_id: "RLBCK",
    descricao: "Back Testing",
    maxWidth: "lg",
    config: {
      title: "Configurações",
      subtitle: "Back Testing",
      descricao: "",
    },
    config_add: {
      title: "Novo",
      subtitle: "Back Testing / Configurações",
      descricao: "",
    },
    config_edit: {
      title: "Editar",
      subtitle: "Back Testing / Configurações",
      descricao: "",
    },
  },
  fronteiraeficiente: {
    id: "fronteiraeficiente",
    output_id: "RLFEF",
    descricao: "Fronteira Eficiente",
    maxWidth: "lg",
    config: {
      title: "Configurações",
      subtitle: "Fronteira Eficiente",
      descricao: "",
    },
    config_add: {
      title: "Novo",
      subtitle: "Fronteira Eficiente / Configurações",
      descricao: "",
    },
    config_edit: {
      title: "Editar",
      subtitle: "Fronteira Eficiente / Configurações",
      descricao: "",
    },
  },
  conferenciacustodiante: {
    id: "conferenciacustodiante",
    output_id: "RLCNC",
    descricao: "Conferência Custodiante",
    maxWidth: "lg",
    config: {
      title: "Configurações",
      subtitle: "Conferência Custodiante",
      descricao: "",
    },
    config_add: {
      title: "Novo",
      subtitle: "Conferência Custodiante / Configurações",
      descricao: "",
    },
    config_edit: {
      title: "Editar",
      subtitle: "Conferência Custodiante / Configurações",
      descricao: "",
    },
  },
};

export default OUTPUT;
